import { createRouter, createWebHistory } from "vue-router";
import { useAuth } from "vue3-oidc";
import AlfredChildrens from "./alfred-front/childrens";
import IssuesChildrens from "./alfred-front/issues";

const OidcCallback = () => import("@/components/OidcCallback.vue");
const MainPages = () => import("@/components/Alfred.vue");
const IssuesLayout = () => import("@/components/alfred/IssuesList.vue");

const routes = [
  {
    path: "/",
    component: MainPages,
    children: [
      ...AlfredChildrens,
      {
        path: "issues",
        component: IssuesLayout,
        children: [
          {
            path: "",
            redirect: { name: "Burndown" },
          },
          ...IssuesChildrens,
        ],
      },
    ],
  },
  {
    path: "/oidc-callback",
    name: "oidcCallback",
    component: OidcCallback,
    meta: {
      isPublic: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.isPublic) {
    next();
    return;
  }
  const { autoAuthenticate, setRedirectUri } = useAuth();
  setRedirectUri(to.fullPath);

  await autoAuthenticate(to.fullPath);

  next();
});

export default router;
